import decoder from '../../../lib/decoder';

function ModelDiscount() {
	this.id = 0;
	this.name = '';
	this.limit = 0;
}

ModelDiscount.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelDiscount();
	
	model.id = decoder.intValue(json['id'], 0);
	model.name = decoder.stringValue(json['name'], '');
	model.limit = decoder.stringValue(json['count_limit'], '');
	
	return model;
};

export default ModelDiscount;